// extracted by mini-css-extract-plugin
module.exports = {"headerTabs":"HeaderTabs_headerTabs__1kbEq","active":"HeaderTabs_active__2ndFL"};